import { isUsingCustomHours } from './is_using_custom_hours'

export const isUsingSecondarySchedule = (membership) => {
  const { primary_availability_rule_id: defaultHoursId, active_availability_rule_id: activeRuleId } = membership
  return !isUsingCustomHours(membership) && (!!activeRuleId && defaultHoursId !== activeRuleId)
}
